import * as React from "react";
import { forwardRef } from "react";
import styled, { css } from "styled-components";
import { CELL_SEP } from "logview/Constants";
import { TableHead } from "views/components/datatable";
import BulkSelectCell from "logview/components/BulkSelectCell";
import useSelectableLogViewMessages from "logview/components/contexts/useSelectableLogViewMessages";
import { VISUALIZATION_TABLE_HEADER_HEIGHT } from "views/Constants";
import BulkSelectHead from "logview/components/BulkSelectHead";
import LogViewCell from "./LogViewCell";
const LogViewTableHead = styled(TableHead)(
  ({ theme }) => css`
    color-adjust: exact !important; /* Needed for report generation */
    align-items: center;
    /* This styling is slightly different compared to the message table widget, because the message table is an actual table */
    height: auto;
    min-height: ${VISUALIZATION_TABLE_HEADER_HEIGHT}px;
    min-width: fit-content;

    border-bottom: 1px solid ${theme.colors.table.row.divider};

    &:last-child {
      border-bottom: 0;
    }

    &:hover {
      background-color: ${theme.colors.gray[90]};
      color: initial;
    }
  `
);
const InnerContainer = styled.div(
  ({ theme }) => css`
    padding: 3px 5px;
    display: flex;
    min-width: fit-content;
    background-color: ${theme.colors.table.head.background};
    gap: ${theme.spacings.xxs};
  `
);
const BulkSelectCol = () => {
  const { selectableLogViewMessages } = useSelectableLogViewMessages();
  return /* @__PURE__ */ React.createElement(BulkSelectCell, { role: "columnheader" }, /* @__PURE__ */ React.createElement(BulkSelectHead, { data: selectableLogViewMessages }));
};
const LogViewHeader = ({ columns, displayBulkSelectCol = false }, ref) => /* @__PURE__ */ React.createElement(LogViewTableHead, { as: "div", ref }, /* @__PURE__ */ React.createElement(InnerContainer, null, displayBulkSelectCol && /* @__PURE__ */ React.createElement(BulkSelectCol, null), columns.toArray().map((fieldName) => /* @__PURE__ */ React.createElement(React.Fragment, { key: `table-header-cell-${fieldName}` }, /* @__PURE__ */ React.createElement(LogViewCell, { fieldName, role: "columnheader" }, fieldName), fieldName !== columns.last() ? CELL_SEP : null))));
export default forwardRef(LogViewHeader);
